<div class="separatorCenter">
    <h4>Copiar Configuração do Usuário - {{uas.user.nome}}</h4>
</div>
<div class="content">
    <nz-spin [nzSpinning]="copyLoading" nzSize="large">
    <div class="tem-field">
        <label class="tem-field-label">Filtrar Usuários</label>
        <nz-input-group [nzSuffix]="clearFilter">
            <input nz-input (keyup)="updateFilterUser($event)" [(ngModel)]="userInputFilter">
        </nz-input-group>
        <ng-template #clearFilter>
            <nz-icon *ngIf="userInputFilter" nzType="close-circle" class="clear-icon" (click)="updateFilterUser(null);userInputFilter=''"></nz-icon>
        </ng-template>
    </div>
    <div class="opcao">
            <label class="switch-label">
                <nz-switch [(ngModel)]="copyLayout"></nz-switch>
                <span>Copiar Telas</span>
            </label>
            <div class="flex-spacer"></div>
            <label class="switch-label">
                <nz-switch [(ngModel)]="copyFilter"></nz-switch>
                <span>Copiar Filtros</span>
            </label>
    </div>
    <div class="label-users">
        <h5 class="lblUsuDest">Usuários Destino</h5>
        <div class="flex-spacer"></div>
        <h5 class="lblUsuDest">Usuários Selecionados: {{getSelectedUsers()}}</h5>
    </div>
    <nz-spin nzSimple *ngIf="loadingDataUsers"></nz-spin>
    <div class="select-list">
        <label nz-checkbox class="user-option" *ngFor="let user of tempUserData" [(ngModel)]="user.selected" (ngModelChange)="onNgModelChange(user)">
            {{user.name}}
        </label>
    </div>
    </nz-spin>
</div>
<div class="finish">
    <button nz-button nzType="primary" (click)="finalizar($event)" cdkFocusInitial>Copiar</button>
    <span class="span10"></span>
    <button nz-button nzDanger (click)="cancelar()">Cancelar</button>
</div>
